/* eslint-disable react/prop-types */
import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { List, CellMeasurerCache, CellMeasurer } from "react-virtualized";
import Loading from "../../common/Loading";

import { generateUniqueId } from "../../../utils";

const CallList = ({
  loading,
  calls,
  onCallClick,
  onSortedChange,
  heightDiff,
  noRowsRenderer
}) => {
  const [sortBy, setSortBy] = useState({
    sort: "arrival_date",
    direction: "asc"
  });

  const columns = [
    {
      Header: "Status",
      accessor: "stageObj.label"
    },
    {
      Header: "Tech",
      accessor: "userObj.full_name"
    },
    {
      Header: "Department",
      accessor: "departmentObj.code"
    },
    {
      Header: "Call Type",
      accessor: "typeObj.label"
    },
    {
      Header: "Customer",
      accessor: "customerObj.name"
    },
    {
      Header: "Project",
      accessor: "projectObj.name"
    },
    {
      Header: "Date",
      accessor: "arrival_date"
    },
    {
      Header: "Actual",
      accessor: "actual_hrs"
    },
    {
      Header: "Billable",
      accessor: "billable_hrs"
    }
  ];

  const cache = new CellMeasurerCache({
    fixedWidth: true,
    minHeight: 50
  });

  const rowRenderer = ({ index, key, parent, style }) => {
    const call = calls[index];
    return (
      <CellMeasurer
        cache={cache}
        columnIndex={0}
        key={key}
        rowIndex={index}
        parent={parent}
      >
        {({ registerChild }) => (
          <div
            ref={registerChild}
            key={call._id}
            className="list-item"
            disabled={loading}
            style={style}
            role="presentation"
            onKeyDown={() => {}}
            onClick={() => onCallClick(call)}
          >
            <div
              className="call-item"
              style={
                call.highlight ? { background: "rgba(255, 0, 0, 0.2)" } : {}
              }
            >
              {/* <Badge className="fixed-width" color={call?.stageObj ? call?.stageObj.color : "#ccc"}>
                {call?.stageObj ? call?.stageObj.label : "--"}
              </Badge> */}
              <p>{call?.stageObj?.label || ""}</p>
              <p>{call?.userObj?.full_name || ""}</p>
              <p>{call?.departmentObj?.code || ""}</p>
              <p>{call?.typeObj?.label || ""}</p>
              <p>{call?.customerObj?.name || ""}</p>
              <p>{call?.projectObj?.name || ""}</p>
              <p>
                {call.arrival_date
                  ? moment(call.arrival_date).format("M/D/YYYY")
                  : "--"}
              </p>
              <p>{call.actual_hrs ? call.actual_hrs.toFixed(1) : "0.0"}</p>
              <p>{call.billable_hrs ? call.billable_hrs.toFixed(1) : "0.0"}</p>
            </div>
          </div>
        )}
      </CellMeasurer>
    );
  };

  const onSort = (column) => {
    if (sortBy.sort === column) {
      const direction = sortBy.direction === "asc" ? "desc" : "asc";
      onSortedChange(column, direction);
      setSortBy({
        sort: column,
        direction
      });
    } else {
      onSortedChange(column, "asc");
      setSortBy({
        sort: column,
        direction: "asc"
      });
    }
  };

  if (loading)
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Loading />
      </div>
    );

  return (
    <div className="call-container">
      <div className="call-item header">
        {columns.map((column) => (
          <p
            key={generateUniqueId()}
            role="presentation"
            onKeyDown={() => {}}
            onClick={() => onSort(column.accessor)}
          >
            {column.Header}
            {column.accessor === sortBy.sort && (
              <span style={{ fontSize: 7 }}>
                {sortBy.direction === "asc" ? "▲" : "▼"}
              </span>
            )}
          </p>
        ))}
      </div>
      <List
        data={calls}
        width={1024}
        height={window.innerHeight - heightDiff}
        containerStyle={{
          width: "100%",
          maxWidth: "100%"
        }}
        style={{
          width: "100%"
        }}
        overscanRowCount={0}
        rowCount={calls.length}
        rowHeight={cache.rowHeight}
        rowRenderer={rowRenderer}
        noRowsRenderer={noRowsRenderer}
      />
    </div>
  );
};

CallList.propTypes = {
  loading: PropTypes.bool,
  calls: PropTypes.array,
  onCallClick: PropTypes.func,
  onSortedChange: PropTypes.func,
  heightDiff: PropTypes.number,
  noRowsRenderer: PropTypes.func
};

CallList.defaultProps = {
  loading: false,
  calls: [],
  onCallClick: () => null,
  onSortedChange: () => null,
  heightDiff: 0,
  noRowsRenderer: () => null
};

export default CallList;
